<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiProgressClock } from "@mdi/js";
export default {
  name: "MdiProgressClock",
  data() {
    return {
      svgPath: mdiProgressClock,
    };
  },
};
</script>
